import React, { lazy, Suspense, useState } from 'react';
import { Menu , Spin, Drawer } from 'antd';
import {  MenuOutlined, CloseOutlined, WechatOutlined } from '@ant-design/icons';
import { HashRouter, Route, Routes, useNavigate } from 'react-router-dom' ;
import { useViewport } from './contexts/ViewportContext';
import ScrollToTop from '../src/components/scrollToTop';
import { useScroll } from './contexts/ScrollContext';
import { ScrollProvider } from './contexts/ScrollContext';
import { ViewportProvider } from './contexts/ViewportContext';
import HomePage from './pages/homePage';
import wechatQd from './images/wechat.png'
import logo from './images/tunan1.jpeg'
import './App.scss'
 
const ApplicationArea = lazy(() => import('./pages/applicationArea'));
const AboutUs = lazy(() => import('./pages/aboutUs'));
const Digitizing = lazy(() => import('./pages/digitizing'));
const DataOriented = lazy(() => import('./pages/dataOriented'));
const Ai = lazy(() => import('./pages/ai'));
const ConnectUs = lazy(() => import('./pages/connectUs'));
// const HomePage = lazy(() => import ( './pages/homePage' ))
 
const AppMenu = () => {
  const navigate = useNavigate();
  const { width } = useViewport();
 
  const isScrolled = useScroll();
 
  const prefixCls = 'app';
 
  const items = [
    {
      label: '首页',
      key: 'home',
    },
    {
      label: '服务优势',
      key: 'server',
      children: [
        { label: '软件定制开发', key: 'sofeware' },
        { label: 'AI', key: 'ai' },
        { label: '数字化转型集成', key: 'digitizing'},
        { label: '面向数据要素', key: 'dataOriented' },
      ]
    },
    // {
    //   label: '应用领域',
    //   key: 'application',
    // },
    {
        label: '关于我们',
        key: 'aboutUs',
      },
];
 
const [drawerVisible, setDrawerVisible] = useState(false);
const [showModal, setShowModal] = useState(false)
 
  const showDrawer = () => {
    setDrawerVisible(true);
  };
 
  const closeDrawer = () => {
    setDrawerVisible(false);
  };
 
  const handleClick = (e: { key: any; }) => {
    switch (e.key) {
      case 'home':
        navigate('/');
        break;
      case 'sofeware':
        navigate('/server/sofeware');
        break;
      case 'ai':
        navigate('/server/ai');
        break;
      case 'digitizing':
        navigate('/server/digitizing');
        break;
      case 'dataOriented':
        navigate('/server/dataOriented');
        break;
      case 'application':
        navigate('/server/sofeware');
        break;
      case 'aboutUs':
        navigate('/server/aboutUs');
        break;
      default:
        break;
    }
    width < 768 && closeDrawer();
  };
  return <div className='app'>
  <div className={`${prefixCls}-top-nav`} style={{background: isScrolled ? '#fff' : '', boxShadow: isScrolled? '0 0 10px #a5a5a5':''}}>
  <div className={`${prefixCls}-top-nav-bannar`} style={{color: isScrolled ? '#bebebe' : ''}}>
      <div className={`${prefixCls}-top-nav-bannar-lable`}>
        <img src={logo} style={{width:'144px',height:'auto'}} alt='TuNan'/>
      </div>
      <div className={isScrolled ? `${prefixCls}-top-nav-bannar-tab ${prefixCls}-top-nav-bannar-crollStyle`: `${prefixCls}-top-nav-bannar-tab`}>
      {width >= 768 ?
      // defaultSelectedKeys={['home']}
        <Menu onClick={handleClick} mode="horizontal" items={items} disabledOverflow />
        :
        <>
          {/* <Button type="primary" icon={<MenuOutlined color='#333'/>} onClick={showDrawer}>
          </Button> */}
          <div onClick={drawerVisible ? closeDrawer : showDrawer}>
            {drawerVisible ? <CloseOutlined /> : <MenuOutlined color='#333'/>}
          </div>
          <Drawer
            style={{marginTop:'70px'}}
            className="custom-drawer"
            title="Menu"
            placement="right"
            closable={false}
            onClose={closeDrawer}
            visible={drawerVisible}
            width="100%"
            // drawerStyle={{ top: '70px' }}
            bodyStyle={{ padding: 0 }}
            headerStyle={{ display: 'none' }}
          >
            <Menu mode="inline" onClick={handleClick} items={items}></Menu>
          </Drawer>
        </>
      }
      </div>
        <div className={`${prefixCls}-top-nav-bannar-subtitle`}>
          <div onClick={ () => navigate('/connectUs') }>联系我们</div>
          <div style={{marginLeft:'20px'}} onClick={ () => {setShowModal(true)} }>
              <WechatOutlined style={{ fontSize: '20px' }}/>
          </div>
        </div>
  </div>
  {
    showModal && <div className={`${prefixCls}-top-nav-bannar-modal`}>
      <div className={`${prefixCls}-top-nav-bannar-modal-text`}>
        <span>微信公众号：</span>
        <div onClick={ () => {setShowModal(false)} }>
          <CloseOutlined style={{width:'20px'}}/>
        </div>
      </div>
      <img src={wechatQd} style={{width:'144px',height:'auto'}}/>
    </div>
  }
</div>
</div>
}
 
function App() {  
  return (
    <ViewportProvider>
      <ScrollProvider>
       <HashRouter>
        <ScrollToTop />
        <AppMenu />
        <Suspense fallback={<Spin size="large" style={{ display: 'block', margin: '20px auto' }} />}>
         <Routes>
          <Route path="/" element={<HomePage  />} />
          <Route path="/server/sofeware" element={<ApplicationArea  />} />
          <Route path="/server/aboutUs" element={<AboutUs  />} />
          <Route path="/server/digitizing" element={<Digitizing />} />
          <Route path="/server/dataOriented" element={<DataOriented />} />
          <Route path="/server/ai" element={<Ai />} />
          <Route path="/connectUs" element={<ConnectUs />} />
         </Routes>
         </Suspense>
       </HashRouter>
       </ScrollProvider>
      </ViewportProvider>
  );
}
 
export default App;
